import { Routes } from '@amzn/atoz-shiftapp-initializer';
export var getRequestTimeOffPath = function (pathname) {
    if (pathname)
        return "".concat(Routes.RequestTimeOff, "?").concat(new URLSearchParams({
            source: pathname
        }));
    else
        return Routes.RequestTimeOff;
};
